<ui-section
	[collapsable]="true"
	[collapsed]="shouldCollapseSignal()"
	[title]="sectionTitle"
	(onCollapsedChange)="onCollapsedChange($event)"
	[titleImg]="titleImgConfig_()"
	[testHook]="testHooks.TitleSection"
>
	<div section-content class="grid grid-cols-2 gap-12">
		<div class="flex flex-col gap-6 h-fit">
			<div class="flex flex-col gap-4">
				<h4 class="text-lg font-medium text-gray-950 m-0">Provider</h4>
				<app-select
					[required]="true"
					label="Set Default Provider"
					[ngModel]="defaultProvider_()"
					(ngModelChange)="setDefaultProvider($event)"
					[testHook]="testHooks.SetDefaultProviderSelect"
				>
					@for (option of titleInsProviderOptions; track option.value) {
						<option [value]="option.value" [testHook]="testHooks.Option">
							{{ option.label }}
						</option>
					}
				</app-select>
			</div>
			<div
				class="flex flex-col gap-4"
				*ngIf="defaultProvider_() !== titleInsuranceProvider.MANUAL"
			>
				<h4 class="text-lg font-medium text-gray-950 m-0">Fee Placement</h4>

				<app-direction-of-amount />

				@if (directionOfAmount_()?.location !== doaLocations.NONE) {
					<ui-note title="Note" [testHook]="testHooks.Note">
						<p>
							Greater than $10.00 shows in Statement of account. Less than or
							equal to $10.00 will show in Trust ledger.
						</p>
					</ui-note>
				}
			</div>
		</div>

		@if (
			defaultProvider_() !== titleInsuranceProvider.MANUAL &&
			directionOfAmount_()?.location !== doaLocations.NONE
		) {
			<div class="flex flex-col gap-4 h-fit">
				<h4 class="text-lg font-medium text-gray-950 m-0">
					Additional Settings
				</h4>

				<div class="flex flex-col gap-6">
					<ui-button-segmented
						label="Extend counsel credit to client"
						[selectedId]="extendConnectingCounsel_()"
						[options]="extendCounselCreditOptions"
						[fullWidth]="true"
						(selectedIdChange)="setExtendConnectingCounsel($event)"
						variant="text-only"
						labelSize="md"
						[testHook]="testHooks.ExtendCounselCreditToClientButtonSegmented"
					/>

					<ui-checkbox
						*ngIf="!defaultSettings_()?.titleInsurance?.extendConnectingCounsel"
						label="Combine premium and counsel credit"
						[ngModel]="defaultSettings_()?.titleInsurance?.combineCounselFee"
						(ngModelChange)="setCombineCounselFee($event)"
						[testHook]="testHooks.CombinePremiumAndCounselCreditCheckbox"
					/>

					@if (hasShowCounselCredit_()) {
						<ui-checkbox
							label="Show counsel credit as a fee on the statement of account"
							[ngModel]="defaultSettings_()?.titleInsurance?.showCounselCredit"
							(ngModelChange)="setShowCounselCredit($event)"
							[testHook]="testHooks.ShowCounselCreditAsFeeCheckbox"
						/>
					}

					<ui-checkbox
						*ngIf="
							directionOfAmount_()?.location === doaLocations.SOA &&
							directionOfAmount_()?.amount > 0
						"
						label="Subject to HST in Statement of Account"
						[ngModel]="directionOfAmount_()?.subjectToHSTInSOA"
						(ngModelChange)="setSubjectToHST($event)"
						[testHook]="testHooks.SubjectToHstInStatementOfAccountCheckbox"
					/>
				</div>
			</div>
		}
	</div>
</ui-section>
